<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	import SingleRowView from '../../components/GenericView/SingleRowView.svelte';
	import { actionInterpretator } from '../../helpers/scene_actions_to_ui';
	import type { DeviceActionUI } from '../../../../types/DeviceActionUI';
	import type { NotificationActionUI } from '../../../../types/NotificationActionUI';
	import type { SceneActionUI } from '../../../../types/SceneActionUI';
	import { extract_actions_variables } from './extract_actions_variables';
	import type { GroupActionUI } from '../../../../types/GroupActionUI';
	import {
		getDelayedSceneAction,
		getSceneActionPurpose,
	} from '../../helpers/get_delayed_scene_action';

	import { Label, Stack } from '@Shelly/shelly-design-system';

	export let element; //only action types will be here, but its possible to be do or [do, delay], [delay, do]

	const dispatch = createEventDispatcher();

	const delayedAction = getDelayedSceneAction(element);
	let msg_type = element.msg_type;
	let purpose = getSceneActionPurpose(element, delayedAction);

	let display_modal = false;

	if (delayedAction !== undefined && element.wait !== undefined) {
		//if there is do => it is a delay action, stupid, but in other way we miss it
		element = { ...delayedAction, delay: element.wait, units: element.units };
	}
	let translated: NotificationActionUI | DeviceActionUI | SceneActionUI | GroupActionUI | undefined =
		actionInterpretator(purpose, element, msg_type);

	const { title, subtitle, labelList, withLabelList, avatar, description, actionList } =
		extract_actions_variables(translated);

	const handle_click = () => {
		display_modal = true;
	};
</script>

<SingleRowView
	{withLabelList}
	{labelList}
	{avatar}
	{title}
	{subtitle}
	{description}
	on:click={() => {
		dispatch('edit-do');
	}}
	on:open_detailed={() => handle_click()}
/>

{#if actionList && actionList.length > 0}
	<Stack gap="s" class="mt-s">
		{#each actionList as { icon, name }}
			<Label class="width-full justify-content-start" {icon} value={name} size="s" />
		{/each}
	</Stack>
{/if}
